import { container } from "tsyringe";
const SSE_LOG_MAX = 200;
const sseLog = [];
const log = (msg) => {
    const entry = `${new Date().toISOString().substring(11, 23)} ${msg}`;
    sseLog.push(entry);
    if (sseLog.length > SSE_LOG_MAX)
        sseLog.shift();
};
// Access from browser console: window.SSE_DEBUG()
if (typeof window !== 'undefined') {
    window.SSE_DEBUG = () => { sseLog.forEach(l => console.log(l)); return `${sseLog.length} entries`; };
    window.SSE_LOG = sseLog;
}
export class BookInSseSocket {
    static getInstance() {
        if (this.instance === undefined) {
            this.instance = new BookInSseSocket();
        }
        return this.instance;
    }
    createGuid() {
        const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
        const guid = `${s4()}${s4()}-${s4()}-${s4()}-${s4()}-${s4()}${s4()}${s4()}`;
        const guidSession = sessionStorage.getItem('guid');
        if (guidSession)
            return guidSession;
        sessionStorage.setItem('guid', guid);
        return guid;
    }
    constructor() {
        this.eventSource = null;
        this.reconnectAttempts = 0;
        this.maxReconnectAttempts = 10;
        this._eventBus = container.resolve('IEventBus');
        this.connect();
    }
    connect() {
        if (this.eventSource) {
            this.eventSource.close();
            this.eventSource = null;
        }
        const gatewayHttp = process.env.REACT_APP_GATEWAY_HTTP;
        const guid = this.createGuid();
        this.eventSource = new EventSource(`${gatewayHttp}/api/Eda/Sse/Stream?id=${guid}`);
        this.eventSource.onopen = () => {
            this.reconnectAttempts = 0;
            log(`OPEN guid:${guid}`);
        };
        this.eventSource.onmessage = this.onMessage.bind(this);
        this.eventSource.onerror = () => {
            var _a;
            if (((_a = this.eventSource) === null || _a === void 0 ? void 0 : _a.readyState) === EventSource.CLOSED) {
                this.eventSource = null;
                if (this.reconnectAttempts < this.maxReconnectAttempts) {
                    this.reconnectAttempts++;
                    const delay = Math.min(1000 * this.reconnectAttempts, 10000);
                    log(`CLOSED reconnecting in ${delay}ms (attempt ${this.reconnectAttempts})`);
                    setTimeout(() => this.connect(), delay);
                }
                else {
                    log('MAX RETRIES reached');
                }
            }
        };
    }
    disconnect() {
        if (this.eventSource) {
            this.eventSource.close();
            this.eventSource = null;
            log('DISCONNECT');
        }
    }
    send(message) {
        const gatewayHttp = process.env.REACT_APP_GATEWAY_HTTP;
        const guid = sessionStorage.getItem('guid') || this.createGuid();
        message.idSession = guid;
        const postUrl = `${gatewayHttp}/api/Eda/Sse/Event`;
        const body = JSON.stringify(message);
        const headers = { 'Content-Type': 'application/json' };
        log(`POST ${message.event} guid:${guid}`);
        fetch(postUrl, { method: 'POST', headers, body }).catch(() => {
            log('POST FAILED retrying');
            setTimeout(() => {
                fetch(postUrl, { method: 'POST', headers, body }).catch(err => log(`POST RETRY FAILED ${err}`));
            }, 1000);
        });
    }
    onMessage(messageEvent) {
        const raw = messageEvent.data;
        setTimeout(() => {
            try {
                const obj = JSON.parse(raw);
                if (obj.heartbeat)
                    return;
                if (obj.event !== undefined) {
                    log(`EVENT ${obj.event} size:${raw.length}`);
                    const parsed = obj.data ? JSON.parse(obj.data) : obj;
                    this._eventBus.dispatch(obj.event, parsed);
                }
            }
            catch (e) {
                log(`PARSE ERROR ${e === null || e === void 0 ? void 0 : e.message}`);
            }
        }, 0);
    }
}
BookInSseSocket.instance = undefined;
